import React, { useState } from 'react'
import Countdown from "react-countdown";
import ImageDropdown from '../Home/ImageDropdown';
const LaunchCard = () => {
    const options = [
        { image: "/images/eth.png", value: "USDT", label: "USDT" },
        { image: "/images/eth.png", value: "ETH", label: "ETH" },
      ];
    
      const [selectedOption, setSelectedOption] = useState(options[0]);
      const Completionist = () => <span>You are good to go!</span>;
    
      const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          return <Completionist />;
        } else {
          return (
            <div className="d-flex mt-4 countdown justify-content-center">
              <div className="p-2">
                <h2 className="time-num">{days}:</h2>
              </div>
              <div className="p-2">
                <h2 className="time-num">{hours}:</h2>
              </div>
              <div className="p-2">
                <h2 className="time-num">{minutes}:</h2>
              </div>
              <div className="p-2">
                <h2 className="time-num">{seconds}</h2>
              </div>
            </div>
          );
        }
      };
  return (
    <div className=''>
           <div className="launch-card">
              <p>This round ends in :</p>
              <div className="timer">
                <Countdown
                  date={new Date(Date.now() + 1000 * 160 * 160 * 124)}
                  renderer={(props) => {
                    if (props.completed) {
                      return "Your time is over";
                    } else {
                      return renderer(props);
                    }
                  }}
                />
              </div>
              <div className="pt-3 pb-3">
                <div className="d-flex align-items-center justify-content-between ">
                  <p>Presale Stage 1</p>
                  <span className="d-flex align-items-center gap-2">
                    RAISED <p style={{ color: "#91EB4A" }}>$963,685</p>
                  </span>
                </div>
                <div
                  class="progress"
                  style={{ height: "1px", margin: "5px 0px" }}
                >
                  <div
                    class="progress-bar"
                    role="progressbar"
                    style={{ width: "25%" }}
                    aria-valuenow="25"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>
                <div className="text-end">
                  <span>Target :$ 1,2500,00</span>
                </div>
                <div>
                  <p className="text-center">1 5SCAPE</p>
                  <h1 className="text-center pt-3">$ 0.00187</h1>
                </div>
                <div className="row pt-4">
                  <div className="col-12 col-sm-12">
                    <div className="price mb-2 mb-sm-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <p>LISTING PRICE</p>
                        <p className="d-flex align-items-center gap-2">
                          $0.001 <p style={{ color: "#91EB4A" }}>(433.76 %)</p>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12">
                    <div className="price">
                      <div className="d-flex align-items-center justify-content-between">
                        <p>NEXT PRICE</p>
                        <p className="d-flex align-items-center gap-2">
                          $0.001 <p style={{ color: "#91EB4A" }}>(433.76 %)</p>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row pt-3 relative">
                  <div className="col-lg-6 pb-3 pb-lg-0 ">
                    <div className="card-payment">
                      <h4>Select a Payment Method</h4>
                      <h4 className="pt-2">ETH</h4>
                      <div className="mt-2">
                        <ImageDropdown
                          options={options}
                          onChangeListener={setSelectedOption}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 pb-3 pb-lg-0 ">
                    {" "}
                    <div className="card-payment">
                      <h4 className="text-end">USDT COST</h4>
                      <h4 className="text-end pt-2 ">$0.00</h4>
                      <input type="text" className="usdt" />
                    </div>
                  </div>

                </div>
                <div className="d-flex justify-content-center">

                <div className="football">
                  <img src="/images/football.png" alt="football" />
                </div>
                </div>
                <div className="row pt-3">
                  <div className="col-lg-6 pb-3 pb-lg-0 ">
                    {" "}
                    <div className="card-payment">
                      <h4>BALANCE</h4>
                      <h4 className="pt-2">0 5SCAPE</h4>
                      <div className="scape">
                        <svg
                          width="17"
                          height="18"
                          viewBox="0 0 17 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2356_5722)">
                            <path
                              d="M7.86831 4.26538C8.20989 4.23416 8.55339 4.24313 8.89578 4.24175C11.4922 4.24175 14.0886 4.23986 16.6847 4.24121C16.6842 5.03101 16.6837 5.82109 16.685 6.61087C13.945 6.61195 11.2047 6.60978 8.46467 6.61141C7.7182 6.61141 6.94361 6.78028 6.33534 7.23397C5.90557 7.54808 5.6051 8.01887 5.45717 8.5282C5.3514 8.88279 5.31111 9.25393 5.30948 9.62316C4.52273 9.62018 3.73595 9.62316 2.94946 9.62154C2.95136 8.81355 3.08469 7.99743 3.41168 7.25514C3.79355 6.37058 4.4524 5.61311 5.26675 5.10378C6.04731 4.61264 6.95389 4.34384 7.86831 4.26538Z"
                              fill="white"
                            />
                            <path
                              d="M10.2259 8.90071C10.9359 8.89908 11.6458 8.89881 12.3558 8.90071C12.3512 9.56398 12.2552 10.2316 12.0163 10.8522C11.7094 11.6657 11.1528 12.3811 10.4387 12.8741C9.57328 13.4787 8.51064 13.7589 7.46343 13.7668C4.97545 13.7668 2.48777 13.766 9.15527e-05 13.766C0.0025257 13.053 0.00144391 12.3403 0.00036207 11.6274C2.31659 11.6285 4.63279 11.6274 6.94874 11.6268C7.25489 11.6225 7.56241 11.6336 7.86695 11.5967C8.40517 11.534 8.94419 11.357 9.36989 11.0116C9.66686 10.774 9.88998 10.4504 10.0255 10.0956C10.1707 9.71602 10.2281 9.30605 10.2259 8.90071Z"
                              fill="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2356_5722">
                              <rect
                                width="16.6849"
                                height="16.6849"
                                fill="white"
                                transform="translate(0.00012207 0.69519)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <h4 >5SCAPE</h4>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 pb-3 pb-lg-0 ">
                    {" "}
                    <div className="card-payment">
                      <h4 className="text-end">USDT COST</h4>
                      <h4 className="text-end pt-2">$0.00</h4>
                      <input type="text" className="usdt" placeholder="0"  style={{textAlign:"end"}}/>

                    </div>
                  </div>
                </div>
              </div>
            <button className="connect-btn">Connect Walllet</button>
            <div className="work-btn">
            How it works
            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.2664 6.00622C16.546 5.72666 16.546 5.2734 16.2664 4.99384L11.7108 0.438169C11.4312 0.15861 10.978 0.15861 10.6984 0.438169C10.4188 0.717728 10.4188 1.17098 10.6984 1.45054L14.7479 5.50003L10.6984 9.54952C10.4188 9.82908 10.4188 10.2823 10.6984 10.5619C10.978 10.8415 11.4312 10.8415 11.7108 10.5619L16.2664 6.00622ZM0.260254 6.21589H15.7603V4.78418H0.260254V6.21589Z" fill="white"/>
</svg>

            </div>
            </div>
    </div>
  )
}

export default LaunchCard